import { render, staticRenderFns } from "./SubmitInfoCard.vue?vue&type=template&id=2ee97728&"
import script from "./SubmitInfoCard.vue?vue&type=script&lang=js&"
export * from "./SubmitInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports